import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import TextInput from "new_components/molecules/TextInput";

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
`;

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NameAndDescription = ({
  data,
  onUpdate,
  draftData,
  toggleAnonymity,
  errors,
}) => {
  const [surveyName, setSurveyName] = useState(data?.name || "");
  const [surveyDescription, setSurveyDescription] = useState(data?.description || "");
  const [organizationName, setOrganizationName] = useState(data?.organizationName || "");
  const [organizationNameFr, setOrganizationNameFr] = useState(data?.organizationNameFr || "");

  // Always set anonymity to true on mount
  useEffect(() => {
    if (toggleAnonymity) {
      toggleAnonymity(true);
    }
  }, []);

  // Handle draft data initialization
  useEffect(() => {
    if (draftData && draftData?.name) {
      setSurveyName(draftData?.name || "");
      setSurveyDescription(draftData?.description || "");
      setOrganizationName(draftData?.organizationName || "");
      setOrganizationNameFr(draftData?.organizationNameFr || "");
    }
  }, [draftData]);

  const updateAllData = (updates) => {
    onUpdate({
      name: surveyName,
      description: surveyDescription,
      organizationName: organizationName,
      organizationNameFr: organizationNameFr,
      ...updates,
    });
  };

  const handleNameChange = (value) => {
    setSurveyName(value);
    updateAllData({ name: value });
  };

  const handleDescriptionChange = (value) => {
    setSurveyDescription(value);
    updateAllData({ description: value });
  };

  const handleOrganizationNameChange = (value) => {
    setOrganizationName(value);
    updateAllData({ organizationName: value });
  };

  const handleOrganizationNameFrChange = (value) => {
    setOrganizationNameFr(value);
    updateAllData({ organizationNameFr: value });
  };

  return (
    <SectionWrapper>
      {/* Name Field */}
      <FieldWrapper>
        <TextInput
          label="Name of the survey"
          value={surveyName}
          onChange={handleNameChange}
          placeholder="Enter the name of the survey"
          error={errors?.surveyNameValidation}
        />
      </FieldWrapper>

      {/* Description Field */}
      <FieldWrapper>
        <TextInput
          label="Description"
          value={surveyDescription}
          error={errors?.surveyDescriptionValidation}
          onChange={handleDescriptionChange}
          placeholder="Enter a description"
        />
      </FieldWrapper>

      {/* Organization Name Field */}
      <FieldWrapper>
        <TextInput
          label="Organization Name (English) *"
          value={organizationName}
          error={errors?.organizationNameValidation}
          onChange={handleOrganizationNameChange}
          placeholder="Enter the organization name"
        />
      </FieldWrapper>

      {/* Organization Name French Field */}
      <FieldWrapper>
        <TextInput
          label="Organization Name (French) *"
          value={organizationNameFr}
          error={errors?.organizationNameFrValidation}
          onChange={handleOrganizationNameFrChange}
          placeholder="Entrez le nom de l'organisation"
        />
      </FieldWrapper>
    </SectionWrapper>
  );
};

NameAndDescription.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    organizationName: PropTypes.string,
    organizationNameFr: PropTypes.string,
  }),
  onUpdate: PropTypes.func.isRequired,
  toggleAnonymity: PropTypes.func,
  draftData: PropTypes.object,
  errors: PropTypes.object,
};

NameAndDescription.defaultProps = {
  data: {
    name: "",
    description: "",
    organizationName: "",
    organizationNameFr: "",
  },
  toggleAnonymity: () => {},
  draftData: null,
  errors: null,
};

export default NameAndDescription;
